import React from 'react';
import px from 'prop-types';
import { ProductCompare as Compare } from 'Common/components/product';
import { compare, order } from '~features';
import { useAction } from 'Common/hooks';
import { useSelector } from 'react-redux';
import * as GTM from 'Common/constants/gtm';

export default function ProductCompare({ compareSections, locallyConfig }) {
    const compareList = useSelector(compare.selectors.getCompareItemsDetails);
    const specDefinitions = useSelector(compare.selectors.getSpecDefinitions);
    const isLoading = useSelector(compare.selectors.getLoading);
    const comparedItems = useSelector(compare.selectors.getCompareItems);

    const onGetCompareList = useAction(compare.actions.getCompareList);
    const onRemoveFromCompareList = useAction(compare.actions.removeFromCompareList);
    const onClearCompareList = useAction(compare.actions.clearCompareList);
    const onAddItemToCart = useAction(order.actions.addItem);

    React.useEffect(() => {
        onGetCompareList();
    }, [onGetCompareList]);

    return (
        <Compare
            items={compareList}
            specs={specDefinitions}
            onRemoveFromCompareList={onRemoveFromCompareList}
            onClearCompareList={onClearCompareList}
            onAddItemToCart={onAddItemToCart}
            isLoading={isLoading}
            gtmListValue={GTM.TAGS.COMPARED_ITEM}
            comparedItems={comparedItems}
            compareSections={compareSections}
            locallyConfig={locallyConfig}
        />
    );
}

ProductCompare.propTypes = {
    compareSections: px.arrayOf(
        px.shape({
            title: px.string,
            description: px.string,
            attributeNames: px.arrayOf(px.string),
        })
    ),
    locallyConfig: px.shape({
        companyName: px.string,
        companyId: px.string,
        endpointUrl: px.string,
    }),
};

ProductCompare.defaultProps = {
    compareSections: [],
    locallyConfig: null,
};
